let market_prefix_2 = window.theme.marketPrefix;

if (market_prefix_2 === "main") {
    market_prefix_2 = "";
}

function updateYMALScrollbar() {
    //console.log'updateCarousels called');
    document.querySelectorAll('.ymal-carousel').forEach((carousel) => {
        const carouselId = carousel.dataset.carouselId;
        const slides = Array.from(carousel.querySelectorAll('li.grid__item'))
            .filter(slide => window.getComputedStyle(slide).display !== "none");

        const track = document.querySelector(`.key-features-track-wrapper[data-carousel-id="ymal-carousel"] .carousel-track`);
        const rectangle = track.querySelector('.carousel-rectangle');
  
        rectangle.style.width = `${track.offsetWidth / slides.length}px`;
  
        const trackWidth = track.offsetWidth - rectangle.offsetWidth;
  
        carousel.addEventListener('scroll', () => {
          const scrollLeft = carousel.scrollLeft;
          const scrollWidth = carousel.scrollWidth - slides.reduce((accum, slide) => accum + (window.getComputedStyle(slide).display !== "none" ? 0 : slide.offsetWidth), 0);
          const carouselWidth = carousel.offsetWidth;
          const scrollPercent = scrollLeft / (scrollWidth - carouselWidth);
  
          rectangle.style.transform = `translateX(${scrollPercent * trackWidth}px)`;
        });
    });
}

let ymalGetProductsFrom = $('.product-recommendations').attr('data-get-additional-products-from');

function loadAdditionalYMALProducts(callback) {
    fetch('/collections/'+ ymalGetProductsFrom +'?view=ymal', { method: 'GET' })
    .then(result => result.text())
    .then(YMALProducts => {
        callback(YMALProducts);
        updateYMALScrollbar();
    })
    .catch(errorMsg => { console.log(errorMsg); });
}

function getAllYMALProducts(YMALProducts) {
    var $YMALProducts = $(YMALProducts);
    $YMALProducts.each(function() {
        var productHandle = $(this).data('product-handle');
        if ($('.ymal-carousel li[data-product-handle="' + productHandle + '"]').length === 0) {
            $(".ymal-carousel").append($(this));
        }
    });
}

function getFirstYMALProduct(YMALProducts) {
    var $allProducts = $(YMALProducts); // Assuming YMALProducts is a jQuery object or HTML string
    var $selectedProduct = null;

    $allProducts.each(function() {
        var productHandle = $(this).data('product-handle');
        if ($('.ymal-carousel li[data-product-handle="' + productHandle + '"]').length === 0) {
            $selectedProduct = $(this);
            return false; // Breaks the .each() loop
        }
    });

    if($selectedProduct) {
        $(".ymal-carousel").append($selectedProduct);
        $('.ymal-carousel .dynamically-added-product').addClass('shop-collection-title').append('<span class="reveal-top-ten">Shop Best Sellers</span>');
        $('.ymal-carousel .dynamically-added-product a').attr('href', '/collections/best-sellers');
    }
}

var loadProductRecommendationsIntoSection = function () {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector(".product-recommendations");
    if (productRecommendationsSection === null) {
        return;
    }
    // Read product id from data attribute
    var productId = productRecommendationsSection.dataset.productId;
    var productFamily = productRecommendationsSection.dataset.familyTitle;
    // Read limit from data attribute
    var limit = productRecommendationsSection.dataset.limit;
    // Build request URL
    if (market_prefix_2 === "main") {
        var requestUrl = "/recommendations/products?section_id=product-recommendations&limit=" + limit + "&product_id=" + productId;
    
    } else {
        var requestUrl = market_prefix_2 + "/recommendations/products?section_id=product-recommendations&limit=" + limit + "&product_id=" + productId;

    }
    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function () {
        if (request.status >= 200 && request.status < 300) {
            setTimeout(function () {
        
            }, 1000);

            var container = document.createElement("div");
            container.innerHTML = request.response;
            productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;


            

         

            var tooManyFamilyProducts = false;
            let hasLessThanSix = false;

            var productCount = $(".product-recommendations .grid__item").length;

            $(".product-recommendations .grid__item").each(function () {
                var $this = $(this);
                var familyTitleRelated = $this.attr("data-family-title");

                if (familyTitleRelated === productFamily || familyTitleRelated === "hide product") {
                    $this.remove();
                    if (familyTitleRelated.length > 5) {
                        tooManyFamilyProducts = true;
                    }
                }
            });

            if (productCount < 6) {
                hasLessThanSix = true;
                console.log('has less than 6');
                loadAdditionalYMALProducts(getAllYMALProducts);
            } else {
                loadAdditionalYMALProducts(getFirstYMALProduct);
            }


            if (tooManyFamilyProducts) {
                $(".hidden-extra-products .grid__item").each(function () {
                    var $this = $(this);
                    $this.appendTo(".product-recommendations .product-grid");
                });
            }

            setTimeout(function(){
                updateYMALScrollbar()
            },0100);

        }
    };
    request.send();
};
// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor

// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function() {
    loadProductRecommendationsIntoSection();
});